import core from '~/core/scripts';
import './styles/index.styl';
import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import geolib from 'geolib';
import * as d3Dsv from 'd3-dsv';
import $ from 'jquery';
import {filter, orderBy, head} from 'lodash';
import Geocoder from '~/core/scripts/components/Geocoder';
import { is768Query, is1024Query } from '~/core/scripts/mediaquery-helper';
import {Header, Legend, Samples} from './components/static';
import {Viz, PresetButtons, DownloadButton} from './components/dynamic';
import './pdfkit';
import SVGtoPDF from 'svg-to-pdfkit';
import blobStream from 'blob-stream';

const configData = {
  startYear: 1953,
  endYear: 2023,
  default: ARTICLE_CONFIG.meta.default,
  presets: [
    {city: "Berlin", geocodes: {longitude:13.37691, latitude: 52.51605}},
    {city: "Köln", geocodes: {longitude:6.8272407, latitude: 50.9578353}},
    {city: "Hamburg", geocodes: {longitude:9.647645, latitude: 53.5582447}},
    {city: "Erfurt", geocodes: {longitude:10.9452962, latitude: 50.9854275}},
    {city: "Braunschweig", geocodes: {longitude:10.3878027, latitude: 52.2721095}},
    {city: "Essen", geocodes: {longitude:6.9459789, latitude: 51.4409934}},
    {city: "Winterberg", geocodes: {longitude:8.373398, latitude: 51.2006155}}
  ]
}


const { dsvFormat } = d3Dsv;
if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!./index.html');

  if (location.pathname.includes('.html')) {
    const fileToLoad = location.pathname.replace('.html', '.js');
    try {
      require(`./layout-samples${fileToLoad}`);
    } catch(e) {
      console.log(e);
      console.log(`[Starterkit] no file found ${fileToLoad}`);
    }
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.csv = dsvFormat(',');
    this.state = {
      geocode: null,
      stations: null,
      data: null,
      presets: configData.presets,
      isDesktop: is1024Query(),
      isTablet: is768Query(),
      activePreset: "",
      currentLabel: "",
      downloadUrl: null
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    $.get('data/daten.csv').done(res => {
      const data = this.csv.parse(res);
      this.setState(prevState => ({
        data: data,
        stations: getStations(configData.default.geocodes, data),
        currentLabel: configData.default.city
      }), () => this.createPdf());
    });
    window.addEventListener('resize', this.onResize);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentLabel !== this.state.currentLabel) {
      this.createPdf();
    }
  }

  onResize = () => {
    const isDesktop = is1024Query();
    const isTablet = is768Query();

    if (isDesktop === this.setState.isDesktop) {
      return false;
    } else if (isTablet === this.setState.isTablet) {
      return false;
    }

    this.setState({
      isDesktop: is1024Query(),
      isTablet: is768Query()
    });
  }

  handleSelect(value) {
    const geocodes = { latitude: value.lat, longitude: value.lon };

    this.setState({
      geocode: geocodes,
      stations: getStations(geocodes, this.state.data),
      activePreset: '',
      currentLabel: value.label
    });
  }
  handleClick(value) {
    this.setState({
      geocode: value.geocodes,
      stations: getStations(value.geocodes, this.state.data),
      activePreset: value.city,
      currentLabel: value.city
    });
  }
  createPdf = () => {
    const doc = new PDFDocument({ compress: false });
    const svgElement = document.querySelector('#svg');
    const reader = new FileReader();

    SVGtoPDF(doc, svgElement, 0, 0);

    const stream = doc.pipe(blobStream());

    stream.on('finish', () => {
      const blob = stream.toBlob('application/pdf');
      const url = URL.createObjectURL(blob);
      this.setState({ downloadUrl:  url });
    });

    doc.end();
  }
  render() {
    if(this.state.isDesktop) {
      return (
        <Fragment>
          <div className="cols">
            <div className="col left">
              <Header />
              {/* <Teaser /> */}
              <Geocoder
                onSelect={(response) => this.handleSelect(response)}
              />
              <PresetButtons presets={this.state.presets} onClick={(value) => this.handleClick(value)} activePreset={this.state.activePreset}/>
              <DownloadButton url={this.state.downloadUrl} />
              <Samples />
            </div>
            <div className="col right">
              <Viz stations={this.state.stations} currentLabel={this.state.currentLabel}/>
              <Legend />
            </div>
          </div>
        </Fragment>
      );
    }
    else if(this.state.isTablet) {
      return (
        <Fragment>
          <div className="cols">
            <div className="col left">
              <Header />
              {/* <Teaser /> */}
              <Geocoder
              onSelect={(response) => this.handleSelect(response)}
              />
              <PresetButtons presets={this.state.presets} onClick={(value) => this.handleClick(value)} activePreset={this.state.activePreset}/>
            </div>
            <div className="col right">
              <Viz stations={this.state.stations} currentLabel={this.state.currentLabel}/>
              <Legend />
            </div>
          </div>
          <DownloadButton url={this.state.downloadUrl} />
          <Samples />
        </Fragment>
      );
    }
    else {
      return (
        <Fragment>
          <Header />
          {/* <Teaser /> */}
          <Geocoder
          onSelect={(response) => this.handleSelect(response)}
          />
          <PresetButtons presets={this.state.presets}  onClick={(value) => this.handleClick(value)} activePreset={this.state.activePreset}/>
          <Viz stations={this.state.stations} currentLabel={this.state.currentLabel}/>
          <Legend />
          <DownloadButton url={this.state.downloadUrl} />
          <Samples />
        </Fragment>
      );
    }
  }
}

const appContainer = document.getElementById('app');
if (appContainer) {
  ReactDOM.render((
    <App/>
  ), appContainer);
}

//helper
function getStations(geocode, data) {
  var stations = [];
  if(geocode != null && data != null) {
    for(let year=configData.startYear; year<=configData.endYear; year++) {
      let filteredArray = filter(data,function(o){ return o.YEAR == year.toString()});
      let ordered = orderBy(filteredArray, function(o) {
        return geolib.getDistance(
            {latitude: o.lat, longitude: o.lng},
            {latitude: geocode.latitude, longitude: geocode.longitude},
            1
          );
      });
      stations.push(head(ordered));
    }
    stations.push({YEAR: "2024", SNOW2: 3});
    return stations;
  }
  else {
    return null;
  }
}
